import React from 'react';
import { stats } from '../data/mat';
export function StatsBar() {
  return <section className="w-full border-y border-slate-900/10 bg-stone-100" data-id="element-271" data-mp="1tai49fo3n1tg">
      <div className="mx-auto max-w-6xl px-8 py-14 sm:px-14 lg:flex lg:items-center lg:gap-12" data-id="element-272" data-mp="1tb9s24bgfv96">
        <h2 className="shrink-0 font-serif text-2xl italic leading-tight text-red-700 lg:w-44" data-id="element-273" data-mp="1o9keoi0rf5hx">
          Kompletny pakiet w liczbach
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-3 lg:mt-0 lg:flex-1 lg:grid-cols-5" data-id="element-274" data-mp="1edr4346lpm2s">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse border-l border-slate-900/15 pl-5" data-id="element-275" data-mp="19lpll0iuaz4b">
              <dt className="mt-3 text-sm leading-snug text-slate-900/70" data-id="element-276" data-mp="15lfchezr3sl8">{stat.label}</dt>
              <dd className="font-serif text-5xl leading-none tracking-tight text-slate-900 sm:text-6xl" data-id="element-277" data-mp="10n41v21mte1y">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}